<script>
import { h } from 'vue'
import { mapGetters } from 'vuex'

import { STAFF_STATUS } from '@/models/channels'
import EventWatcher from '@/utils/watchers/EventWatcher'

const activityTime = 300000

export default {
  data() {
    return {
      eventWatcher: null
    }
  },
  computed: {
    ...mapGetters('channel/staff', ['loggedStaff']),
    ...mapGetters('user', ['hasPermissionToGetChat']),
    canInitiateWatcher() {
      return (
        this.loggedStaff.status === STAFF_STATUS.AVAILABLE &&
        this.hasPermissionToGetChat
      )
    }
  },
  watch: {
    'loggedStaff.status'(status) {
      if (status === STAFF_STATUS.UNAVAILABLE) {
        this.stopWatcher()
        return
      }
      this.startWatcher()
    }
  },
  mounted() {
    this.startWatcher()
  },
  beforeUnmount() {
    this.stopWatcher()
  },
  methods: {
    startWatcher() {
      if (!this.canInitiateWatcher || this.eventWatcher) {
        return
      }

      this.eventWatcher = new EventWatcher({
        context: 'CHANNEL',
        activityTime,
        onActivity: this.handleActivity
      })
      this.eventWatcher.startWatcher()
    },
    stopWatcher() {
      if (this.eventWatcher) this.eventWatcher.stopWatcher()
    },
    handleActivity() {
      this.$store.dispatch('channel/staff/staffStatusPing')
    }
  },
  render: () => h('div')
}
</script>
